/**
 * Static content for /2026-workshop Learn and Resources tabs.
 */

import { WORKSHOP_FLYER_PATH } from '../constants/workshopFlyer';

export const WORKSHOP_2026_PDF_BASE = '/content/workshop-2026';

/** Printable 1-page invite with QR code → /2026-workshop */
export const WORKSHOP_INVITE_PDF = WORKSHOP_FLYER_PATH;

export interface PastWorkshop {
  year: string;
  summaryKey: string;
}

/** Full history shown in the past-workshops FAQ. */
export const PAST_WORKSHOPS: PastWorkshop[] = [
  { year: '2025–2026', summaryKey: 'workshop.2026.faq.past.2025_2026' },
  { year: '2024–2025', summaryKey: 'workshop.2026.faq.past.2024_2025' },
  { year: '2023', summaryKey: 'workshop.2026.faq.past.2023' },
  { year: '2022', summaryKey: 'workshop.2026.faq.past.2022' },
  { year: '2021', summaryKey: 'workshop.2026.faq.past.2021' },
  { year: '2019–2021', summaryKey: 'workshop.2026.faq.past.2019_2021' },
  { year: '2018–2019', summaryKey: 'workshop.2026.faq.past.2018_2019' },
  { year: '2016–2017', summaryKey: 'workshop.2026.faq.past.2016_2017' },
  { year: '2013–2015', summaryKey: 'workshop.2026.faq.past.2013_2015' },
  { year: '2011–2012', summaryKey: 'workshop.2026.faq.past.2011_2012' },
  { year: '2009–2010', summaryKey: 'workshop.2026.faq.past.2009_2010' },
];

/** @deprecated Use PAST_WORKSHOPS */
export const PAST_WORKSHOPS_RECENT = PAST_WORKSHOPS.slice(0, 3);

/** @deprecated Use PAST_WORKSHOPS */
export const PAST_WORKSHOPS_FULL = PAST_WORKSHOPS;

export interface WorkshopResourceLink {
  label: string;
  href: string;
  description?: string;
  external?: boolean;
}

export const WORKSHOP_DOCUMENTS: WorkshopResourceLink[] = [
  {
    label: 'Introduction to the SAA Step Workshop',
    href: `${WORKSHOP_2026_PDF_BASE}/introduction-to-saa-step-workshop.pdf`,
    external: true,
  },
  {
    label: 'Invitation / overview',
    href: WORKSHOP_INVITE_PDF,
    description: 'One-page printable flyer with QR code to the workshop page.',
    external: true,
  },
];

export const RECOVERY_TOOLS: WorkshopResourceLink[] = [
  {
    label: 'Recovery Prayers',
    href: `${WORKSHOP_2026_PDF_BASE}/recovery-prayers.pdf`,
    external: true,
  },
  {
    label: '3 Circles Worksheet',
    href: '/saa/12-steps/getting-started',
    description: 'Personal 3 Circles tool on the Getting Started page.',
  },
];

export const SAA_MEETINGS_LINK: WorkshopResourceLink = {
  label: 'Find SAA meetings worldwide',
  href: 'https://www.saa-meetings.org',
  external: true,
};

export const FUTURE_LEADERS: WorkshopResourceLink[] = [
  {
    label: 'Starting and Running an SAA Step Workshop',
    href: `${WORKSHOP_2026_PDF_BASE}/starting-and-running-saa-workshop.pdf`,
    external: true,
  },
];
